import type { Call } from '@twilio/voice-sdk'
import type { AppelAgent, EvenementAppel } from './types'

/** A Twilio Voice SDK call behind the carrier-agnostic `AppelAgent`. */
export class AppelTwilio implements AppelAgent {
  readonly fournisseur = 'twilio' as const
  readonly call: Call

  constructor(call: Call) {
    this.call = call
  }

  get id(): string | null {
    return this.call.parameters?.CallSid || null
  }

  get de(): string {
    return this.call.parameters?.From || ''
  }

  accept() {
    this.call.accept()
  }

  reject() {
    this.call.reject()
  }

  disconnect() {
    this.call.disconnect()
  }

  mute(muet: boolean) {
    this.call.mute(muet)
  }

  sendDigits(chiffres: string) {
    this.call.sendDigits(chiffres)
  }

  on(evenement: EvenementAppel, rappel: (erreur?: unknown) => void) {
    this.call.on(evenement, rappel)
  }

  removeAllListeners() {
    this.call.removeAllListeners()
  }
}
